import {ENV_CONFIG} from '../../../../env-config';

export const environment = {
  origin: '',
  production: true,
  firebase: ENV_CONFIG.firebase,
  firebaseEmulators: false
};
